<template>
    <div>
        <Navbar v-if="isLoggedIn"></Navbar>
        <
        <b-card
            class="mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
        >
            <b-card-title v-if="!isLoggedIn" class="text-center">
                <div
                class="col-12 pt-4 pb-4 text-center"
                :class="gdqmodeclass"
                style="color: white;"
                >
                <img
                    src="../assets/GDQ-Associates-White.svg"
                    width="300"
                    alt="GDQ Logo"
                >
                </div>
            </b-card-title>
            <b-alert
                :show="message != ''"
                :class="error != '' ? 'text-black':'text-white'"
                :variant="error != '' ? 'danger':'success'"
                dismissible
                @dismissed="message = ''"
                class="text-center"
            >
                {{ message }}
            </b-alert>
            <h1 class="text-center">Mail Preferences</h1>
            <h5>Welcome to your GDQ mail preferences!</h5>
            <p>
                This page allows you to set your preferences for which e-mails you wish to receive from GDQ Associates. You can change your preferences at any time.
            </p>
            <b-form-group label="Newsletter">
                <b-form-checkbox
                    v-model="newsletter"
                    name="newsletter"
                    value="1"
                    unchecked-value="0"
                >
                    Yes, I wish to receive the regular GDQ Newsletter (uncheck the box if you do not wish to receive the newsletter)
                </b-form-checkbox>
            </b-form-group>
            <b-form-group label="General Emails">
                <b-form-checkbox
                    v-model="general_emails"
                    name="general_emails"
                    value="1"
                    unchecked-value="0"
                >
                    Yes, I wish to receive general information e-mails from GDQ Associates, for example information about upcoming events, news in the GDQ Platform and other information for GDQ Consultants.
                </b-form-checkbox>
            </b-form-group>
            <b-button
                @click="preferences_set"
                variant="primary"
                class="mt-3"
            >
                Save
            </b-button>
        </b-card>
    </div>
</template>
<script>
import { config } from '../../config.js'
import Navbar from './Navbar.vue'
export default {
  name: 'ConsultantMailPreferences',
  components: {
    Navbar
  },
  data () {
    return {
      id: 0,
      token: this.$route.params.t ? this.$route.params.t : '',
      newsletter: 0,
      general_emails: 1,
      isLoggedIn: this.$store.getters.isLoggedIn,
      gdqmodeclass: (config.mode == 'live') ? 'bg-primary' : config.mode == 'stage' ? 'bg-warning' : 'bg-danger',
      message: '',
      error: ''
    }
  },
  created () {
    this.preferences_get()
  },
  methods: {
    preferences_get () {
      console.log({ isLoggedIn: this.isLoggedIn })
      this.$store.dispatch('consultant_mailpreferences_fetch', { subscription_token: this.token })
        .then((resp) => {
          this.id = resp.data.id
          this.newsletter = resp.data.newsletter
          this.general_emails = resp.data.general_emails
          this.error = resp.data.error
        })
    },
    preferences_set () {
      this.$store.dispatch('consultant_mailpreferences_save', { id: this.id, newsletter: this.newsletter, general_emails: this.general_emails })
        .then((resp) => {
          this.error = resp.data.error
          this.message = resp.data.error == '' ? 'Preferences saved' : this.error
        })
    }
  }
}
</script>
<style>
</style>
